'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.roomingListsData = exports.transferServiceData = exports.resourceData = exports.requirementData = exports.profilesData = exports.departureServicesData = exports.customersData = exports.checkinData = exports.primaryCustomerData = exports.bookingMetaData = exports.bookingData = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.deprecatedFlights = deprecatedFlights;

var _redux = require('redux');

var _bookingDataActions = require('actions/bookingDataActions');

var _bookingMetaDataActions = require('actions/bookingMetaDataActions');

var _checkinDataActions = require('actions/checkinDataActions');

var _customersDataActions = require('actions/customersDataActions');

var _departureServicesDataActions = require('actions/departureServicesDataActions');

var _deprecatedFlightStatusActions = require('actions/deprecatedFlightStatusActions');

var _profilesDataActions = require('actions/profilesDataActions');

var _requirementDataActions = require('actions/requirementDataActions');

var _primaryCustomerDataActions = require('../actions/primaryCustomerDataActions');

var _resourcesActions = require('../actions/resourcesActions');

var _transferServicesDataActions = require('../actions/transferServicesDataActions');

var _roomingListsDataActions = require('actions/roomingListsDataActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateApiCallReducer = function generateApiCallReducer(requestAction, receivedAction, failedAction) {
    return function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case requestAction:
                return (0, _extends3.default)({}, state, {
                    isFetching: true,
                    error: null // clear error when new request is dispatched
                });
            case receivedAction:
                return (0, _extends3.default)({}, state, {
                    canLoad: true, // flags that data can safely be selected from state
                    isFetching: false
                });
            case failedAction:
                return (0, _extends3.default)({}, state, {
                    isFetching: false,
                    error: action.error || action.errors
                });
            default:
                return state;
        }
    };
};

var bookingData = exports.bookingData = generateApiCallReducer(_bookingDataActions.BOOKING_DATA_REQUESTED, _bookingDataActions.BOOKING_DATA_RECEIVED, _bookingDataActions.BOOKING_DATA_REQUEST_FAILED);

var bookingMetaData = exports.bookingMetaData = generateApiCallReducer(_bookingMetaDataActions.BOOKING_META_DATA_REQUESTED, _bookingMetaDataActions.BOOKING_META_DATA_RECEIVED, _bookingMetaDataActions.BOOKING_META_DATA_REQUEST_FAILED);

var primaryCustomerData = exports.primaryCustomerData = generateApiCallReducer(_primaryCustomerDataActions.PRIMARY_CUSTOMER_DATA_REQUESTED, _primaryCustomerDataActions.PRIMARY_CUSTOMER_DATA_RECEIVED, _primaryCustomerDataActions.PRIMARY_CUSTOMER_DATA_REQUEST_FAILED);

var checkinData = exports.checkinData = generateApiCallReducer(_checkinDataActions.CHECKIN_DATA_REQUESTED, _checkinDataActions.CHECKIN_DATA_RECEIVED, _checkinDataActions.CHECKIN_DATA_REQUEST_FAILED);

var customersData = exports.customersData = generateApiCallReducer(_customersDataActions.CUSTOMERS_DATA_REQUESTED, _customersDataActions.CUSTOMERS_DATA_RECEIVED, _customersDataActions.CUSTOMERS_DATA_REQUEST_FAILED);

var departureServicesData = exports.departureServicesData = generateApiCallReducer(_departureServicesDataActions.DEPARTURE_SERVICES_DATA_REQUESTED, _departureServicesDataActions.DEPARTURE_SERVICES_DATA_RECEIVED, _departureServicesDataActions.DEPARTURE_SERVICES_DATA_REQUEST_FAILED);

var profilesData = exports.profilesData = generateApiCallReducer(_profilesDataActions.PROFILES_DATA_REQUESTED, _profilesDataActions.PROFILES_DATA_RECEIVED, _profilesDataActions.PROFILES_DATA_REQUEST_FAILED);

var requirementData = exports.requirementData = generateApiCallReducer(_requirementDataActions.REQUIREMENT_DATA_REQUESTED, _requirementDataActions.REQUIREMENT_DATA_RECEIVED, _requirementDataActions.REQUIREMENT_DATA_REQUEST_FAILED);

var resourceData = exports.resourceData = generateApiCallReducer(_resourcesActions.RESOURCES_UPDATE_REQUESTED, _resourcesActions.RESOURCES_UPDATE_SUCCEEDED, _resourcesActions.RESOURCES_UPDATE_FAILED);

var transferServiceData = exports.transferServiceData = generateApiCallReducer(_transferServicesDataActions.TRANSFER_SERVICES_DATA_RECEIVED, _transferServicesDataActions.TRANSFER_SERVICES_DATA_REQUESTED, _transferServicesDataActions.TRANSFER_SERVICES_DATA_REQUEST_FAILED);

// Does not follow same pattern as api call reducers above
function deprecatedFlights() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        case _deprecatedFlightStatusActions.DEPRECATED_FLIGHT_STATUS_ADDED:
            return [].concat((0, _toConsumableArray3.default)(state), [action.flightStatusHref]);
        case _deprecatedFlightStatusActions.DEPRECATED_FLIGHT_STATUS_OVERWRITTEN:
            return state.filter(function (x) {
                return x !== action.flightStatusHref;
            });
        default:
            return state;
    }
}
var roomingListsData = exports.roomingListsData = generateApiCallReducer(_roomingListsDataActions.ROOMING_LISTS_DATA_REQUESTED, _roomingListsDataActions.ROOMING_LISTS_DATA_RECEIVED, _roomingListsDataActions.ROOMING_LISTS_DATA_REQUEST_FAILED);

exports.default = (0, _redux.combineReducers)({
    bookingData: bookingData,
    bookingMetaData: bookingMetaData,
    primaryCustomerData: primaryCustomerData,
    transferServiceData: transferServiceData,
    checkinData: checkinData,
    customersData: customersData,
    departureServicesData: departureServicesData,
    profilesData: profilesData,
    requirementData: requirementData,
    resourceData: resourceData,
    roomingListsData: roomingListsData,
    deprecatedFlights: deprecatedFlights
});


//////////////////
// WEBPACK FOOTER
// ./app/reducers/apiCalls.js
// module id = 1391
// module chunks = 0